/** 协议 §5.9.2：band.vgs raw 0–255 ↔ 2.600–3.110 V */
export const VGS_VOLT_MIN = 2.6;
export const VGS_VOLT_STEP = 0.002;
export const VGS_RAW_MAX = 255;

export function vgsRawToVolts(raw: number): number {
  const clamped = Math.min(VGS_RAW_MAX, Math.max(0, raw));
  return Number((VGS_VOLT_MIN + clamped * VGS_VOLT_STEP).toFixed(3));
}

export function vgsVoltsToRaw(volts: number): number {
  return Math.min(
    VGS_RAW_MAX,
    Math.max(0, Math.round((volts - VGS_VOLT_MIN) / VGS_VOLT_STEP)),
  );
}

/** 协议 §5.9.2：驻波类 raw ÷ 10，上限 25.5 */
export function swrRawToDisplay(raw: number): number {
  return Number((Math.min(255, Math.max(0, raw)) / 10).toFixed(1));
}

export function swrDisplayToRaw(value: number): number {
  return Math.min(255, Math.max(0, Math.round(value * 10)));
}
